"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when no section of given sectionId exists
 * @param {string} courseId
 * @param {string} sectionId
 */
class SectionDoesNotExistError extends client_library_1.ExtendableError {
    constructor(courseId, sectionId) {
        super(`section: ${sectionId} (courseId: ${courseId}) does not exist`);
        this.courseId = courseId;
        this.sectionId = sectionId;
    }
}
exports.default = SectionDoesNotExistError;
//# sourceMappingURL=SectionDoesNotExistError.js.map